import React, { useEffect, useContext, useState, useRef } from "react";
import { userContext } from "../../../../context/userContext";
import { environmentVariables } from "../../../../config/env.config";
import { useParams, useLocation } from "react-router-dom";
import { getTimeZone } from "../../getTimeZone";
import { businessObjContext } from "../../../../context/businessObjContext";
import SubContactInfo from "./SubContactInfo";
import SubSocialMedia from "./SubSocialMedia";
import SubService from "./SubService";
import SubTestimonial from "./SubTestimonial";
import SubGoogleReview from "./SubGoogleReview";
import SubAlternateUrls from "./SubAlternateUrls";
// import io, { socketIOClient } from "socket.io-client";
import SubBusinessHoursData from "./SubBusinessHoursData";
import CalanderIconn from "../../../../Images/DarkcalendarIcondays.png";
import axios from "axios";
import QRCode from "qrcode.react";
import Star1 from "../../../../Images/Img1FullStar.png";
// import "./TemplatComman.css";
// import "./Template11.css";
// import styles from "./Theme1.module.css";
import "./Theme32.css";
import { ToastContainer, toast } from "react-toastify";
import CircularLoader from "../../../Components/CircularLoader/CircularLoader";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import banner from "../../../../Images/banner32.png";
import logo from "../../../../Images/logo32.png";
import GalleryCarousel from "./GalleryCarousel";
import QrCodeGenerator from "../theme6/QRCode";
import whiteCircle from "../../../../../src/Images/white-circle.png";
import { getAvailableSlots, getContactImageData, getcoutryfromlocation, getFilterContactInfo, getSocialLinkData } from "../../../../utils/utility";
import moment from "moment";
import { useFormik } from "formik";
import PhoneInput from "react-phone-input-2";
import { contactFormSchema } from "../../../../common/contacFormSchema";
import { initializeFacebookPixel } from "../../../Components/FacebookPixel";
import { isValidPhoneNumberAppoitment } from "../../../Components/AppointmentValidation";

// const socket = io.connect(`${environmentVariables?.apiUrl}`);
const Theme32Ext = (props) => {
  const rs = props.rs;
  const [businessLink, setBusinessLink] = useState("");
  const [storedData, setStoredData] = useState(
    localStorage.getItem("businessObj")
  );
  const [socialLinks, setSocialLinks] = useState({
    "Youtube":"",
    "Instagram":"",
    "Facebook":"",
    "LinkedIn":"",
    "Twitter":"",
  });
  const [contactImage, setContactImage] = useState(""); 
  
  const baseUrl = environmentVariables?.apiUrl;
  const { userData } = useContext(userContext);
  let { param } = useParams();
  const [pparam, setPparam] = useState([]);
  const [isSubmitContact, setIsSubmitContact] = useState(false);
  const [isSubmitAppointment, setIsSubmitAppointment] = useState(false);
  const [showTimeSlots, setShowTimeSlots] = useState(false);
  const [theme, setTheme] = useState();
  const searchParams = new URLSearchParams(window.location.search);
  const appParams=searchParams.get('isApp');
  const paramValue = searchParams.get("param");
  const location = useLocation();
  // const [rs, setRs] = useState({});
  const [appointmentdata, setAppointmentdata] = useState();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [loadingAppointment, setLoadingAppointment] = useState(false);
  const [galleryObject, setGalleryObject] = useState(null);
  const [textareaValue, setTextareaValue] = useState("");
  const [backColor, setBackColor] = useState();
  const createUserRef = useRef(null);

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString();
  const { businessObjData } = useContext(businessObjContext);
  const [order, setOrder] = useState(null);

  const [appointmentName, setAppointmentName] = useState("");
  const [appointmentEmail, setAppointmentEmail] = useState("");
  const [appointmentContactNumber, setAppointmentContactNumber] = useState("+971-" || "");
  const [appointmentCountryCode, setAppointmentCountryCode] = useState("uae");  
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  // console.log(selectedTime, "selectedTime");
  const [minDate, setMinDate] = useState("");

  const [errorMsgName, setErrorMsgName] = useState("");
  const [errorMsgEmail, setErrorMsgEmail] = useState("");
  const [errorMsgNo, setErrorMsgNo] = useState("");
  const [errorMsgText, setErrorMsgText] = useState("");
  const calendarInputRef = useRef(null);
  const [countrya, setCountry] = useState("");
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  // const [countryCode, setCountryCode] = useState("uae");

  useEffect(() => {
    const scrollToSection = () => {
      const element = document.getElementById("BookAppointmentAccess");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      } else {
        setTimeout(scrollToSection, 100);
      }
    };
    if (window.location.hash === "#BookAppointmentAccess") {
      scrollToSection();
    }
  }, []);
  useEffect(() => {
    // Set the minimum date to the current date
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    setMinDate(formattedDate);
  }, []);
  // useEffect(() => {
  //   socket.emit("join_room", rs?.created_by);
  // }, [socket]);
  const getAppointmentData = async (date) => {
    setLoadingAppointment(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${environmentVariables?.apiUrl}api/v1/appointment/fetchAppointmentSlots?userId=${userData?.id}&businessId=${rs?.id}&date="${date}"`,
      headers: {
        _token: userData?.token,
      },
    };

    try {
      const response = await axios.request(config);
      // console.log(
      //   response?.data?.response[0]?.slot,
      //   "responseofgetappointmentdata"
      // );
      setLoadingAppointment(false);
      let slotData = response?.data?.response[0]?.slot;
      let filteredSlots = await getAvailableSlots(slotData, date);
      return filteredSlots;
    } catch (error) {
      console.log(error);
      setLoadingAppointment(false);

      return error?.message;
    }
  };

  const handleChangeAppointmentDate = async (dateVal) => {
    let newDate = moment(dateVal).format("YYYY-MM-DD");
    setShowTimeSlots(true);
    setSelectedDate(dateVal);
    // const dateObject = new Date(dateVal);

    // const dayIndex = dateObject.getDay();

    // const daysOfWeek = [
    //   "Sunday",
    //   "Monday",
    //   "Tuesday",
    //   "Wednesday",
    //   "Thursday",
    //   "Friday",
    //   "Saturday",
    // ];
    // console.log(rs?.appointmentObj?.content, "appointmentinsidetheme1date");
    try {
      // const parsedContent = JSON.parse(JSON.parse(rs?.appointmentObj?.content));
      // setAppointmentdata(
      //   parsedContent[`${daysOfWeek[dayIndex].toLowerCase()}`]
      // );
      const appointments = await getAppointmentData(newDate);
      setAppointmentdata(appointments);
    } catch (err) {
      console.log(err);
    }
  };
  const handleButtonClick = () => {
    setIsButtonClicked(true);
  };

  let ff = rs?.contactInfo?.content;

  if (ff?.length) {
    ff = JSON?.parse(ff);
  }
  if (ff?.length) {
    ff = JSON?.parse(ff);
  }
  const getThemeNumber = (themeNum) => {
    return themeNum.split("-").pop();
  };
  const getBackColor = (backColor) => {
    const color = backColor.split("-")[0];
    if (color == "color1") {
      return "#F9D254";
    } else if (color == "color2") {
      return "#8ECAE6";
    } else if (color == "color3") {
      return "#F9D254";
    } else if (color == "color4") {
      return "#FDF0D5";
    } else {
      return "#F9D254";
    }
  };

  useEffect(() => {
    const path = location?.pathname;
    const pathParts = path.split("/");
    setPparam(pathParts);
  }, [location]);

  const getImage = (image) => {
    if (image.includes("base64")) {
      return image;
    } else {
      return `${environmentVariables?.apiUrl}uploads/${image}`;
    }
  };

  function isValidPhoneNumber(phoneNumber) {
    const phonePattern = /^\d{10,12}$/; // Assuming a 10-digit phone number

    return phonePattern.test(phoneNumber);
  }

  const isValidName = (name) => {
    // This regex pattern allows letters (both uppercase and lowercase), hyphens, and spaces.
    const nameRegex = /^[A-Za-z -]+$/;
    return nameRegex.test(name);
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
    return emailRegex.test(email);
  };

  // const getPlanName = () => {
  //   const path = location.pathname;
  //   const pp = path.split("/");
  //   axios
  //     .get(`${baseUrl}api/v1/business/fetchBusinessBySlug`, {
  //       params: { slug: props?.Slug },
  //       headers: {
  //         //   _token: userData?.token,
  //       },
  //       // withCredentials: true,
  //     })
  //     .then((res) => {
  //       console.log(res?.data?.data?.theme_color, "ERERER");
  //       setRs(res?.data?.data);
  //       let appointmentData2 = [];
  //       if (
  //         res?.data?.data &&
  //         res?.data?.data?.appointmentObj &&
  //         res?.data?.data?.appointmentObj?.content
  //       ) {
  //         appointmentData2 = JSON.parse(
  //           res?.data?.data?.appointmentObj?.content
  //         );

  //         if (Array.isArray(appointmentData2)) {
  //           setAppointmentdata(appointmentData2);
  //         }
  //       }

  //       console.log(appointmentData2, "appointmentdata 22324 rs rs");
  //       setGalleryObject(JSON.parse(res?.data?.data?.gallaryObj?.content));
  //       setBackColor(getBackColor(res?.data?.data?.theme_color));
  //       console.log(
  //         getTemplateId(res?.data?.data?.theme_color.split("-").pop()),
  //         "template id number"
  //       );
  //       setTheme(getTemplateId(res?.data?.data?.theme_color.split("-").pop()));
  //     })
  //     .catch((err) => {
  //       console.log({ msg: "err", err: err });
  //     });
  // };

  // console.log("Paddddddrts:", pparam);

  useEffect(() => {
    if (storedData != "undefined") {
      const businessData = JSON.parse(storedData);
      const slugb = businessData?.slug;
      const originUrl = window.location.origin;
      setBusinessLink(`${originUrl}/${slugb}`);
    }
  }, [storedData]);

  // useEffect(() => {
  //   getPlanName();
  // }, []);

  const changeTimeFormat = (time24) => {
    // Split the time string into hours and minutes
    const [hours, minutes] = time24.split(":").map(Number);

    // Create a Date object with today's date
    const date = new Date();

    // Set the hours and minutes to the Date object
    date.setHours(hours);
    date.setMinutes(minutes);

    // Format the time in AM/PM format
    const time12 = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    return time12;
  };
  let contactInfo = props?.rs?.contactInfo?.content;
  if (contactInfo?.length) {
    contactInfo = JSON.parse(contactInfo);
  }
  if (contactInfo?.length) {
    contactInfo = JSON.parse(contactInfo);
  }
  useEffect(()=>{
    getSocialMediaLinks();
    getContactImage();
  },[rs])
  const getContactImage = async()=>{
    let imageData = await getContactImageData(rs?.id);
    setContactImage(imageData);
  }

  const getSocialMediaLinks = async()=>{
    let youtubeLink = await getSocialLinkData(props?.rs?.SocialMediaObj, 'Youtube');    
    let instagramLink = await getSocialLinkData(props?.rs?.SocialMediaObj, 'Instagram');
    let faceBookLink = await getSocialLinkData(props?.rs?.SocialMediaObj, 'FaceBook');
    let linkedinLink = await getSocialLinkData(props?.rs?.SocialMediaObj, 'linkedin');
    let twitterLink = await getSocialLinkData(props?.rs?.SocialMediaObj, 'Twitter');
    let tiktokLink = await getSocialLinkData(props?.rs?.SocialMediaObj, 'tiktok');
    let snapchatLink = await getSocialLinkData(props?.rs?.SocialMediaObj, 'snapchat');
    let googlereviewLink = await getSocialLinkData(props?.rs?.SocialMediaObj, 'google');
    let getCOntactInfo = await getFilterContactInfo(contactInfo?.contactInfoAddress);


    setSocialLinks({
      ...socialLinks,
      Youtube: !!youtubeLink?youtubeLink:"",
      Instagram: !!instagramLink?instagramLink:"",
      Facebook:!!faceBookLink?faceBookLink:"",
      LinkedIn:!!linkedinLink?linkedinLink:"",
      Twitter:!!twitterLink?twitterLink:"",
      Tiktok:!!tiktokLink?tiktokLink:"",
      Snapchat:!!snapchatLink?snapchatLink:"",
      Googlereview:!!googlereviewLink?googlereviewLink:"",
      getCOntactInfo: getCOntactInfo || "",
    });
  }
  const VCardContent = `BEGIN:VCARD
VERSION:3.0
N:;${props?.rs?.sub_title};;;
FN:${props?.rs?.sub_title}
ORG:${props?.rs?.title}
TITLE:${props?.rs?.designation}
URL:https://app.businessbay.io/${props?.rs?.slug}
TEL;TYPE=CELL:${contactInfo?.contactInfoPhone}
${contactInfo?.optionalContactInfoPhone ? `TEL;TYPE=CELL;LABEL=AlternateMobile:${contactInfo.optionalContactInfoPhone}` : ''}
EMAIL;TYPE=INTERNET:${contactInfo?.contactInfoEmail}
ADR;TYPE=HOME:;${socialLinks?.getCOntactInfo}
URL:${contactInfo?.contactInfoWebUrl}
X-SOCIALPROFILE;TYPE=YouTube:${socialLinks?.Youtube}
X-SOCIALPROFILE;TYPE=Instagram:${socialLinks?.Instagram}
X-SOCIALPROFILE;TYPE=Facebook:${socialLinks?.Facebook}
X-SOCIALPROFILE;TYPE=LinkedIn:${socialLinks?.LinkedIn}
X-SOCIALPROFILE;TYPE=Twitter:${socialLinks?.Twitter}
X-SOCIALPROFILE;TYPE=Tiktok:${socialLinks?.Tiktok}
X-SOCIALPROFILE;TYPE=Snapchat:${socialLinks?.Snapchat}
X-SOCIALPROFILE;TYPE=Googlereview:${socialLinks?.Googlereview}
item1.URL:${socialLinks?.Youtube}
item1.X-ABLabel:YouTube
item2.URL:${socialLinks?.Instagram}
item2.X-ABLabel:Instagram
item3.URL:${socialLinks?.Facebook}
item3.X-ABLabel:Facebook
item4.URL:${socialLinks?.LinkedIn}
item4.X-ABLabel:Linkedin
item5.URL:${socialLinks?.Twitter}
item5.X-ABLabel:Twitter
item6.URL:${socialLinks?.Tiktok}
item6.X-ABLabel:Tiktok
item7.URL:${socialLinks?.Snapchat}
item7.X-ABLabel:Snapchat
item8.URL:${socialLinks?.Googlereview}
item8.X-ABLabel:Googlereview
${!!contactImage? `PHOTO;ENCODING=b;TYPE=JPEG:${contactImage.replace(/^data:image\/\w+;base64,/, '')}`: ''}
X-ABADR:country
X-ABLabel:Title
X-ABLabel:eBusiness Card
NOTE;CHARSET=UTF-8:${props?.rs?.description?.replace(/\s+/g, ' ').trim()}
END:VCARD`;

  const downloadVCard = () => {
    const blob = new Blob([VCardContent], { type: "text/vcard" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "contact.vcf"; // Set the desired filename here

    // Create a click event
    const clickEvent = new MouseEvent("click", {
      bubbles: true,
      cancelable: false,
      view: window,
    });

    // Dispatch the click event
    a.dispatchEvent(clickEvent);

    // Revoke the object URL to free up resources
    window.URL.revokeObjectURL(url);
  };

  // const businessHoursData = JSON.parse(rs.businessHourObj.content);
  const businessHoursData = rs.businessHourObj
    ? JSON.parse(rs.businessHourObj.content)
    : null;

  const changeTimeFormatt = (time24) => {
    // Split the time string into hours and minutes
    const [hours, minutes] = time24.split(":").map(Number);

    // Create a Date object with today's date
    const date = new Date();

    // Set the hours and minutes to the Date object
    date.setHours(hours);
    date.setMinutes(minutes);

    // Format the time in AM/PM format
    const time12 = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    return time12;
  };

  const handleNameChange = (event) => {
    const { value } = event.target;
  
    const alphanumericValue = value.replace(/[^A-Za-z -]/g, "");
  
    formik.setFieldValue("name", alphanumericValue);
  };
  
  const initialValues = {
    name: "",
    email: "",
    contactNumber: "+971-" || "",
    textareaValue: "",
    countryCode: "uae",
  };
  
  let formik = useFormik({
    initialValues: initialValues,
    validationSchema: contactFormSchema,
    onSubmit: async (values, { resetForm }) => {
      console.log("values", values)
  
      let number_last = values.contactNumber?.split("-")?.[1];
      let number_first = values.contactNumber?.split("-")?.[0];
  
      let config = {
        method: "post",
        url: `${environmentVariables?.apiUrl}api/v1/contact/MakeContact`,
        withCredentials: true,
        data: {
          business_id: props.id,
          name: values.name,
          email: values.email,
          dialcode: number_first,
          phone: number_last,
          message: values.textareaValue,
          createdBy: props?.rs?.created_by,
        },
      };
  
      axios
        .request(config)
        .then((response) => {
          toast.success("Thank you for contacting us");
          resetForm();
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || error?.message);
        });
    },
  });
  
  const { values, errors, handleSubmit } = formik;

    const fetchCountryfromlocation = async () => {
      try {
        const countryData = await getcoutryfromlocation();
        formik.setFieldValue("countryCode", countryData?.countryCode.toLowerCase());
        formik.setFieldValue("contactNumber", countryData?.phoneCode);
        setAppointmentCountryCode(countryData?.countryCode.toLowerCase());
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };
   useEffect(() => {
        const pixelId = rs?.pixel_id; 
        initializeFacebookPixel(pixelId);
        fetchCountryfromlocation()
      }, []);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setErrorMsgName("");
  //   setErrorMsgEmail("");
  //   setErrorMsgNo("");
  //   setErrorMsgText("");

  //   if (!name) {
  //     setErrorMsgName("Name is required.");
  //     return;
  //   } else if (!isValidName(name)) {
  //     setErrorMsgName("Only alphabets allowed.");
  //     return;
  //   }

  //   if (!email) {
  //     setErrorMsgEmail("Email is required.");
  //     return;
  //   } else if (!isValidEmail(email)) {
  //     setErrorMsgEmail("Invalid email.");
  //     return;
  //   }

  //   if (!isValidPhoneNumber(contactNumber)) {
  //     setErrorMsgNo(
  //       "Invalid mobile number format."
  //     );
  //     return;
  //   }

  //   if (!textareaValue) {
  //     setErrorMsgText("Message is mandatory");
  //     return;
  //   }

  //   setIsSubmitContact(true);

  //   try {
  //     const response = await axios.post(
  //       `${baseUrl}api/v1/contact/MakeContact`,
  //       {
  //         business_id: props.id,
  //         name,
  //         email,
  //         phone: contactNumber,
  //         message: textareaValue,
  //         createdBy: props?.rs?.created_by,
  //       },
  //       {
  //         headers: {
  //           _token: userData?.token,
  //         },
  //       }
  //     );
  //     // socket.emit("contact", rs?.created_by);
  //     toast.success("Thank you for contacting us", {
  //       position: toast.POSITION.TOP_RIGHT,
  //     });
  //     setIsSubmitContact(false);
  //   } catch (error) {
  //     toast.error(error?.response?.data?.message, {
  //       position: toast.POSITION.TOP_RIGHT,
  //       autoClose: 1000,
  //     });
  //     setIsSubmitContact(false);
  //     console.error("Error:", error);
  //   }
  // };

  useEffect(() => {
    getBlockOrder();
    if (rs?.newGalleryImages) {
      setGalleryObject(rs?.newGalleryImages);
    }
    if (rs?.appointmentObj && rs?.appointmentObj?.content) {
      try {
        // const parsedContent = JSON.parse(
        //   JSON.parse(rs?.appointmentObj?.content)
        // );
        // console.log(parsedContent, "...............//////////////");
        // if (Array.isArray(parsedContent) && parsedContent.length !== 0) {
        // setAppointmentdata(parsedContent);
        // }
        // if (JSON.parse(rs?.appointmentObj?.content)?.length != 0) {
        //   if (JSON.parse(JSON.parse(rs?.appointmentObj?.content))) {
        //     setAppointmentdata(
        //       JSON.parse(JSON.parse(rs?.appointmentObj?.content))
        //     );
        //   }
        // }
      } catch (err) {
        console.log(err);
      }
    }
  }, [rs]);
  const getTemplateId = (theme) => {
    if (theme == "theme1") {
      return "template3";
    } else if (theme == "theme2") {
      return "template4";
    } else if (theme == "theme3") {
      return "template5";
    } else if (theme == "theme4") {
      return "template6";
    } else if (theme == "theme5") {
      return "template7";
    } else if (theme == "theme6") {
      return "template8";
    }
  };

  const openCalendar = () => {
   
    if (calendarInputRef.current) {
      calendarInputRef.current.showPicker();
     
    }
  };
  const getBlockOrder = async () => {
    // const handleGetBlock = async () => {
    try {
      let id = props?.id;

      if (id) {
        let { data: get } = await axios.get(
          `${environmentVariables?.apiUrl}api/v1/business/FetchBlock?business_id=${id}`,
          {
            headers: {
              _token: userData?.token,
            },
            // withCredentials: true,
          }
        );
        // console.log(get?.data?.order, "order data template2");
        setOrder(get?.data?.order);
      }

      // console.log(get.data.order,"Getetgwef")
    } catch (err) {
      console.log(err);
    }
    // };
  };

  const getBlocksOrder = () => {
    let BlocksArray = [];
    for (const key in order) {
      BlocksArray[order[key]] = getJSXElement(key);
    }
    // console.log(order, "AAAA");
    return BlocksArray;
  };

  useEffect(() => {
    if (props?.rs?.contactInfo?.content) {
        const contactInfo = JSON.parse(props?.rs?.contactInfo?.content);
        let phoneNumber = contactInfo?.contactInfoPhone;
        phoneNumber = phoneNumber.replace(/[^\d+]/g, '');

        let countryCode = phoneNumber.match(/^\+(\d{1,3})/)[1];

        if (countryCode.length < 3) {
            if (phoneNumber.startsWith("+971")) {
                countryCode = "971";
            } else if (phoneNumber.startsWith("+91")) {
                countryCode = "91";
            } else if (phoneNumber.startsWith("+1")) {
                countryCode = "1";
            } else {
                countryCode = "default"; 
            }
        }

        switch (countryCode) {
            case '91':
              setCountry('India');
                break;
            case '1':
              setCountry('USA');
                break;
            case '971':
              setCountry('United Arab Emirates');
                break;
            default:
              setCountry('India'); 
                break;
        }
    }
}, [props?.rs?.contactInfo]);

  const getJSXElement = (elemName) => {
    if (elemName == "appointment") {
      if (rs?.appointmentObj?.is_enabled === 1) {
        return (
          <>
            <article class="makeappitmneets sec"  id="BookAppointmentAccess" style={{backgroundColor: props.dynamicBackgroundColor || '' }}>
              <h3 class="sectitle" style={{color: props.dynamicTextDescriptionColor || "" }}>Make Appointment</h3>
              <div class="contact-form">
                {countrya && (
                  <h5 className="colorheading" style={{ marginBottom: "18px",color: `${props.dynamicTextDescriptionColor}B3`  }}>{`${
                    countrya
                  } (GMT${getTimeZone(countrya)})`}</h5>
                )}
                <div class="col-12 mb-3" style={{position:"relative"}}>
                  {/* <input
                    type="date"
                    ref={calendarInputRef}
                    class="form-control clear_string clor-blk"
                    placeholder="Date"
                    name="currentDate"
                    value={selectedDate}
                    min={minDate}
                    onChange={(e) =>
                      handleChangeAppointmentDate(e.target.value)
                    }
                  /> */}
                  <DatePicker
                    selected={selectedDate}
                    ref={calendarInputRef}
                    minDate={new Date()}
                    placeholderText="Date"
                    onChange={
                      (date) =>
                        handleChangeAppointmentDate(date)
                    }
                    className="form-control"
                    popperPlacement="bottom-end"
                    onKeyDown={(e) => {
                      e.preventDefault();
                   }}
                  />
                    {/* <div className="calanderIcon firefox-hide" onClick={openCalendar}><img src={CalanderIconn} alt="Calendar Icon" /></div> */}
                    <div className="calanderIcon firefox-hide" onClick={() => calendarInputRef.current.setOpen(true)}><img src={CalanderIconn} alt="Calendar Icon" /></div>
                </div>
                {showTimeSlots && (
                  <>
                    {loadingAppointment ? (
                      <div className="skeleton-blog">
                        <div className="skeleton-footer"></div>
                      </div>
                    ) : (
                      <div class="col-12 mb-3">
                        <select
                          disabled={appointmentdata?.length == 0}
                          class="form-select"
                          aria-label="Default select example"
                          onChange={(e) => setSelectedTime(e.target.value)}
                        >
                          <option value="Select time">
                            {appointmentdata?.length == 0
                              ? "No Slots Available for Meeting"
                              : "Select time"}
                          </option>
                          {console.log(appointmentdata,"rr88rrr")}
                          {appointmentdata &&
                            appointmentdata?.map((val) => (
                              <option
                                disabled={val.status == "confirm"}
                                key={val?.startDate}
                                value={`${val?.startDate} - ${val?.endDate}`}
                              >
                                {`${val?.startDate} - ${val?.endDate}`}
                              </option>
                            ))}
                        </select>
                      </div>
                    )}
                  </>
                )}
                <div class="col-12 mb-3">
                  <button
                    className="btn btnmakeappitmnets colorcta"
                    data-bs-toggle="modal"
                    data-bs-target="#appotimnets"
                    disabled={!selectedDate || !selectedTime}
                    style={{background: props.dynamicCtaColor, color: props?.dynamicCtaTextColor || ""  }}
                  >
                    Make An Appointment
                  </button>
                </div>
              </div>
            </article>
          </>
        );
      }
    } else if (elemName == "contact_form") {
      if (rs?.is_contact_form_enabled) {
        return (
          <article class="conatctform sec" style={{backgroundColor: props.dynamicMainBackgroundColor }}>
            <h3 class="sectitle" style={{color: props.dynamicTextHeadingColor || "" }}>Contact</h3>
            <div class="contact-form">
              <form onSubmit={handleSubmit}>
                <div class="col-12 mb-3">
                  {/* <label class="form-label">Full Name</label> */}
                  <input
                    type="text"
                    class="form-control clear_string"
                    placeholder="Full Name*"
                    style={{border: props?.dynamicTextHeadingColor ? `1px solid ${props?.dynamicTextHeadingColor}` : ""}}
                    value={formik.values.name}
                    onChange={handleNameChange}
                    onBlur={formik.handleBlur}
                    required=""
                  />
                  {formik.touched.name && formik.errors.name ? (
                    <div
                      style={{
                        fontSize: "14px",
                        color: "red",

                        bottom: "70px",
                      }}
                    >{formik.errors.name}</div>
                  ) : null}
                </div>
                <div class="col-12 mb-3">
                  {/* <label class="form-label">Email address</label> */}
                  <input
                    type="email"
                    class="form-control"
                    style={{border: props?.dynamicTextHeadingColor ? `1px solid ${props?.dynamicTextHeadingColor}` : ""}}
                    placeholder="Email*"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    required=""
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <div
                      style={{
                        fontSize: "14px",
                        color: "red",

                        bottom: "70px",
                      }}
                    >{formik.errors.email}</div>
                  ) : null}
                </div>
                <div class="col-12 mb-3">
                  {/* <label class="form-label">Mobile No.</label> */}
                  <PhoneInput
                    name="contactNumber"
                    value={values.contactNumber}
                    style={{border:props?.dynamicTextHeadingColor ? `1px solid ${props?.dynamicTextHeadingColor}` : "",borderRadius:"10px"}}
                    country={values?.countryCode}
                    countryCodeEditable={false}
                    onChange={(value, country) => {
                      console.log("value, country", value, country)
                      formik.setFieldValue("contactNumber", `+${country.dialCode}-${value.substring(
                        country.dialCode.length
                      )}`);
                      formik.setFieldValue("countryCode", country.dialCode);
                    }}
                    className="DetailsInfoPhoneInput colorctaborder"
                  />
                  {formik.touched.contactNumber && formik.errors.contactNumber ? (
                    <div
                      style={{
                        fontSize: "14px",
                        color: "red",

                        bottom: "70px",
                      }}
                    >{formik.errors.contactNumber}</div>
                  ) : null}
                </div>
                <div class="col-12 mb-3">
                  {/* <label class="form-label">Message</label> */}
                  <textarea
                    class="form-control clear_string"
                    rows="3"
                    style={{border: props?.dynamicTextHeadingColor ? `1px solid ${props?.dynamicTextHeadingColor}` : ""}}
                    placeholder="Message*"
                    required=""
                    name="textareaValue"
                    value={formik.values.textareaValue}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  ></textarea>
                  {formik.touched.textareaValue && formik.errors.textareaValue ? (
                    <div
                      style={{
                        fontSize: "14px",
                        color: "red",

                        bottom: "70px",
                      }}
                    >{formik.errors.textareaValue}</div>
                  ) : null}
                </div>

                <div class="col-12 mb-3">
                  {isSubmitContact ? (
                    <div>
                      <CircularLoader size={20} />
                    </div>
                  ) : (
                    <button type="submit" class="btn btn-submitform" style={{background: props.dynamicCtaColor || '' , color: props?.dynamicCtaTextColor || "" }}>
                      Submit
                    </button>
                  )}
                </div>
              </form>
            </div>
            <ToastContainer />
          </article>
        );
      }
    } else if (elemName === "business_hour") {
      if (rs?.businessHourObj?.is_enabled === 1) {
        //  console.log(businessHoursData, "11111")
        return <SubBusinessHoursData rs={rs} colordata={props}/>;
      }
    } else if (elemName === "contact_info") {
      if (rs?.contactInfo?.is_enabled === 1) {
        return <SubContactInfo rs={rs} colordata={props} />;
      }
    } else if (elemName == "custom_html") {
      return <></>;
    } else if (elemName == "description") {
      return (
        <>
          <article class="abouttemplate sec" style={{backgroundColor: props.dynamicBackgroundColor || "" , marginTop:'18px'}}>
            <h3 class="sectitle" style={{color: props.dynamicTextDescriptionColor }}>About Us</h3>
            
            <p className="para colorheading"
               dangerouslySetInnerHTML={{ 
                __html: rs?.description?.replace(/(?:\r\n|\r|\n)/g, '<br>') 
              }}
               style={{color: `${props.dynamicTextDescriptionColor}B3` || "" }}
            >
            </p>
          </article>
        </>
      );
    } else if (elemName == "gallery") {
      if (rs?.gallaryObj?.is_enabled === 1) {
        return (
          galleryObject && (
            <>
              {/* <article class="businesshour sec">
            <h3 class="sectitle">Gallery </h3>
            <div className="servesboxhere">
              <div className="imgboxhere">
                <img
                  src={
                    galleryObject?.gallaryStr &&
                    `${environmentVariables?.apiUrl}uploads/${galleryObject?.gallaryStr}`
                  }
                  className="mx-auto d-block img-fluid"
                />
              </div>
              {galleryObject?.gallary_video && (
                <div className="imgboxhere mt-3">
                  <video className="mx-auto d-block img-fluid" controls>
                    <source
                      width={100}
                      src={
                        galleryObject?.gallary_video &&
                        `${environmentVariables?.apiUrl}uploads/${galleryObject?.gallary_video}`
                      }
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                </div>
              )}
            </div>
          </article> */}
              <article class="gallery sec sec-common"  style={{backgroundColor: props.dynamicBackgroundColor}}>
                <h3 class="sectitle" style={{color: props.dynamicTextDescriptionColor || "" }}>Portfolio </h3>
                {/* <ul class="gallerylist">
                  {galleryObject?.gallaryArray &&
                    galleryObject?.gallaryArray.map((val) => (
                      <li>
                        <img
                          src={
                            `${environmentVariables?.apiUrl}uploads/${val}`
                            // props?.gallaryObject?.gallaryStr &&
                            // `${environmentVariables?.apiUrl}uploads/${props?.gallaryObject?.gallaryStr}`
                          }
                          className="mx-auto d-block img-fluid"
                        />
                      </li>
                    ))}

                  {galleryObject?.gallary_video && (
                    <li>
                      <video className="mx-auto d-block img-fluid" controls>
                        <source
                          src={
                            galleryObject?.gallary_video &&
                            `${environmentVariables?.apiUrl}uploads/${galleryObject?.gallary_video}`
                          }
                          type="video/mp4"
                        />
                        Your browser does not support the video tag.
                      </video>
                    </li>
                  )}
                </ul> */}
                <div>
                  <GalleryCarousel slides={galleryObject}  colordata={props} />
                </div>
              </article>
            </>
          )
        );
      }
    } else if (elemName == "more") {
      return <></>;
    } else if (elemName === "service") {
      if (rs?.serviceObj?.is_enabled === 1) {
        return <SubService rs={rs}  colordata={props} />;
      }
    } else if (elemName == "social") {
      if (rs?.SocialMediaObj?.is_enabled === 1) {
        return <SubSocialMedia rs={rs}  colordata={props} />;
      }
    } else if (elemName == "testimonials") {
      if (rs?.testimonialObj?.is_enabled === 1) {
        return <SubTestimonial rs={rs}  colordata={props} />;
      }
    } else if (elemName == "google_review") {
      if (rs?.is_enabledGooglereview == 1) {
        return <SubGoogleReview rs={rs}  colordata={props} />;
      }
    } else if (elemName == "alternateUrls") {
      if (rs?.alternatUrlObj?.is_enabled == 1) {
        return  <SubAlternateUrls rs= {rs}  colordata={props} />
      }
    }
  };

  const handleSubmits = async (e) => {
    e.preventDefault();
    setErrorMsgName("");
    setErrorMsgEmail("");
    setErrorMsgNo("");
    setErrorMsgText("");

    if (!appointmentName) {
      setErrorMsgName("Name is required.");
      return;
    } else if (!isValidName(appointmentName)) {
      setErrorMsgName("Only alphabets allowed.");
      return;
    }

    if (!appointmentEmail) {
      setErrorMsgEmail("Email is required.");
      return;
    } else if (!isValidEmail(appointmentEmail)) {
      setErrorMsgEmail("Invalid email.");
      return;
    }

    if (!appointmentContactNumber) {
      setErrorMsgNo("Phone number is required.");
      return;
    } else if (
      !isValidPhoneNumberAppoitment(
        appointmentContactNumber,
        appointmentCountryCode || "IN"
      )
    ) {
      setErrorMsgNo("Invalid phone number for the selected country.");
      return;
    }

    setIsSubmitAppointment(true);

    let number_last = appointmentContactNumber?.split("-")?.[1];
    let number_first = appointmentContactNumber?.split("-")?.[0];

    try {
      const dateObject = new Date(selectedDate);
    dateObject.setHours(12, 0, 0);
      const response = await axios.post(
        `${baseUrl}api/v1/appointment/MakeAppoinments`,
        {
          business_id: props.id,
          name: appointmentName,
          email: appointmentEmail,
          phone: number_last,
          dialcode: number_first,
          date: dateObject.toISOString(),
          time: selectedTime,
          status: "pending",
          createdBy: props?.rs?.created_by,
          // note: textareaValue,
        },
        {
          headers: {
            _token: userData?.token,
          },
        }
      );
      if (response?.data?.success) {
        // socket.emit("appointment", rs?.created_by);
        toast.success(response?.data?.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        setIsSubmitAppointment(false);
        setAppointmentName("");
        setAppointmentEmail("");
        setAppointmentContactNumber("");
        // setTimeout(() => {
        //   window.location.reload();
        // }, 2000);
      }

      // console.log("response Appointmentsave", response?.data);
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
      setIsSubmitAppointment(false);
    }
  };

  return (
    <div id="temp32">
      <div className="main-temaplt" id="temp32">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 wtemplate p-0" style={{backgroundColor: props.dynamicMainBackgroundColor}}>
              <img
                src={rs?.logo ? getImage(rs?.logo) : logo}
                className="mx-auto d-block img-fluid logo-profile"
                style={{border:`5px solid ${props?.dynamicBackgroundColor}`}}
              />
              <article className="imgsechere sec">
                <img
                  src={rs?.banner ? getImage(rs.banner) : banner}
                  className="mx-auto d-block img-fluid coverimghere "
                />
              </article>

              <article class="personalinfo ">
                <div class="innerinfo-a">
                  <h3 className="username  colorheading" style={{color: props.dynamicTextHeadingColor}}>{rs.sub_title}</h3>
                  <p className="titleuser colordescription" style={{color: props.dynamicTextHeadingColor}}>{rs.designation}</p>
                  {/* <p className="companeyname colordescription">
                    {rs.sub_title || "Company Name"}
                  </p> */}
                  {rs?.is_enabledGooglereview && rs?.is_enabledGooglereview ? (

                    <div className="reviewratingcontainer">
                <p className="reviewrating colordescription" style={{ color: props.dynamicTextHeadingColor}}>
                  {/* <StarRating value={props?.rating} totalStars={5} starSize="16px"  /> */}
                  <img src={Star1} style={{width:"25px", paddingRight:"5px"}}/>
                <span className="ratingspan colorheading"  style={{color: props.dynamicTextHeadingColor}}> {rs.rating }</span>star  |  {rs.review } reviews
                  </p>
                </div>
                  ): ""}
                </div>
              </article>

              {getBlocksOrder().map((val) => (val == undefined ? <></> : val))}

              <>
                <div
                  class="modal fade"
                  ref={createUserRef}
                  id="appotimnets"
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                  tabindex="-1"
                  aria-labelledby="staticBackdropLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-header" style={{padding:"10px 20px 10px"}}>
                        <h5 class="modal-title" id="staticBackdropLabel">
                          Make Appointment 
                        </h5>
                        <button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div class="modal-body">
                        <form className="row">
                          <div class="col-12 mb-3">
                            <input
                              type="text"
                              class="form-control clear_string"
                              placeholder="Full Name"
                              value={appointmentName}
                              onChange={(e) =>
                                setAppointmentName(e.target.value)
                              }
                              style={{padding:"12px 25px"}}
                            />
                            <div
                              style={{
                                fontSize: "14px",
                                color: "red",

                                bottom: "70px",
                              }}
                            >
                              {errorMsgName}
                            </div>
                          </div>
                          <div class="col-12 mb-3">
                            <input
                              type="text"
                              class="form-control clear_string"
                              placeholder="Email"
                              value={appointmentEmail}
                              onChange={(e) =>
                                setAppointmentEmail(e.target.value)
                              }
                              style={{padding:"12px 25px"}}
                            />
                            <div
                              style={{
                                fontSize: "14px",
                                color: "red",
                                bottom: "70px",
                              }}
                            >
                              {errorMsgEmail}
                            </div>
                          </div>
                          <div class="col-12 mb-3">
                          <PhoneInput
                              name="appointmentContactNumber"
                              value={appointmentContactNumber}
                              country={appointmentCountryCode}
                              countryCodeEditable={false}
                              onChange={(value, country) => {
                                setAppointmentContactNumber(`+${country.dialCode}-${value.substring(
                                  country.dialCode.length
                                )}`)
                                setAppointmentCountryCode(country.dialCode)
                              }}
                              className="DetailsInfoPhoneInput DetailsInfoPhoneInputsep"
                            />
                            <div
                              style={{
                                fontSize: "14px",
                                color: "red",

                                bottom: "70px",
                              }}
                            >
                              {errorMsgNo}
                            </div>
                          </div>
                          <div class="mb-2 mt-2 col-md-12">
                            {isSubmitAppointment ? (
                              <div>
                                <CircularLoader size={20} />
                              </div>
                            ) : (
                              <button
                                onClick={handleSubmits}
                                class="btn btn-primary me-3 extmakeappointmentsubmitbtn"
                                type="button"
                                style={{backgroundColor: props?.dynamicCtaColor || "" , color: props?.dynamicCtaTextColor || "#fff" }}
                              >
                                <i class="bi bi-check-circle-fill ms-2 "></i>
                                Submit
                              </button>
                            )}
                          </div>
                        </form>
                      </div>
                      <ToastContainer />
                    </div>
                  </div>
                </div>
                {/* <article className="sec makeappitmneets">
                  <h3 class="sectitle">Make Appointment</h3>
                  <div className="contact-form">
                    <div class="col-12 mb-3"><input type="date"
                      class="form-control clear_string"
                      placeholder="Date"
                      name="currentDate"
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.target.value)} /></div>
                    <div class="col-12 mb-3">
                      <select class="form-select" aria-label="Default select example" onChange={(e) => setSelectedTime(e.target.value)}>
                        <option value="Select time" >Select time</option>
                        {appointmentdata?.map((val) => (
                          <option key={val?.startDate} value={`${changeTimeFormat(val?.startDate)} - ${changeTimeFormat(val?.endDate)}`}>
                            {`${changeTimeFormat(val?.startDate)} - ${changeTimeFormat(val?.endDate)}`}
                          </option>
                        ))}
                      </select>

                    </div>
                    <div class="col-12 mb-3">
                      <button className="btn btnmakeappitmnets colorcta" data-bs-toggle="modal" data-bs-target="#appotimnets">Make An Appointment</button>
                    </div>
                  </div>
                </article> */}
              </>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              {appParams==null&&<>
              <div className="fixedd" style={{backgroundColor: props.dynamicBackgroundColor || ""}}>
                <article className="fixedfooter sec">
                  <div className="footerleft" style={{backgroundColor: props.dynamicCtaColor || ""}}>
                    <div
                      className="qrcodeshaere"
                      data-bs-toggle="modal"
                      data-bs-target="#qrscan"
                      style={{color: props.dynamicCtaTextColor || ""}}
                    >
                      <i class="fa-solid fa-qrcode"></i>
                    </div>
                    {/* <div className="share">
                      <i class="fa-solid fa-arrow-up"></i>
                    </div> */}
                  </div>
                  <div className="addtocinatct" onClick={downloadVCard} style={{backgroundColor: props.dynamicCtaColor || "", color: props.dynamicCtaTextColor || ""}}>
                    +Add To Contact
                  </div>
                </article>
              </div></>}
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        id="qrscan"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          {/* <div class="modal-content"> */}
          <div class="modal-body" style={{ position: "relative" }}>
            {/* <article className="personalinfo modal-info "> */}
            {/* {rs && rs?.logo && (
              <img
                className="qr-logo-image"
                // src={`${environmentVariables?.apiUrl}uploads/${rs?.logo}`}
                src={
                  rs?.logo
                    ? `${environmentVariables?.apiUrl}uploads/${rs?.logo}`
                    : whitecircle
                }
              />
            )} */}
            {rs && rs.logo ? (
              <img
                className="qr-logo-image"
                src={`${environmentVariables?.apiUrl}uploads/${rs.logo}`}
              />
            ) : (
              <img
                className="qr-logo-image"
                src={whiteCircle}
                alt="White Circle"
              />
            )}
            {/* <QRCode value={`${window.location.origin}/${rs?.slug}`} /> */}
            <QrCodeGenerator />
            {/* <QRCodes businessObj={businessObjData} /> */}

            {/* <p className="companeyname colordescription">{rs.sub_title || "Company Name"}</p> */}
            {/* </article> */}
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default Theme32Ext;
